export type TaxonomyLevels = {
  [key: string]: string[];
};

export const TAXONOMY_LEVELS: TaxonomyLevels = {
  sneakers: ['boots', 'cleats', 'slip-ons', 'sandals', 'espadrilles'],
  apparel: ['tops', 'bottoms', 'outerwear', 'dresses', 'swimwear', 'activewear', 'tailoring'],
  accessories: [
    'hats',
    'socks-and-tights',
    'belts',
    'wallets',
    'eyewear',
    'technology',
    'gloves',
    'hair-accessories',
    'keychains-and-lanyards',
    'travel',
    'masks',
    'scarves',
    'umbrellas',
    'water-bottles',
  ],
  bags: [
    'shoulder-bags',
    'pouches',
    'top-handles',
    'tote-bags',
    'backpacks',
    'clutches',
    'crossbody-bags',
    'duffles',
    'belt-bags',
  ],
  jewelry: ['bracelets', 'pins'],
  media: ['books', 'magazines', 'music'],
  objects: ['toys', 'vases'],
  home: ['furniture'],
  collectibles: ['skate-boards', 'comics'],
  art: ['prints'],
};
